package nl.appstuff.padelchecker.site

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color
import nl.appstuff.padelchecker.site.localization.SiteLocaleProvider
import org.jetbrains.compose.web.css.vh

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.apply {
        light.apply {
            background = SiteColors.backgroundLight
            color = SiteColors.textLight
        }
        dark.apply {
            background = SiteColors.backgroundDark
            color = SiteColors.textDark
        }
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        SiteLocaleProvider {
            Surface(Modifier.minHeight(100.vh)) {
                content()
            }
        }
    }
}
